import React from 'react';

const LongTermResultsTable = ({ results, onTradeClick, onChartClick }) => {
  if (!results || results.length === 0) {
    return (
      <div className="text-center py-8 text-gray-500">
        <p>No investment opportunities found matching the criteria.</p>
        <p className="text-sm mt-2">Try analyzing different indices or adjusting the period.</p>
      </div>
    );
  }

  const formatNumber = (value, decimals = 2) => {
    if (value === null || value === undefined) return '-';
    return Number(value).toFixed(decimals);
  };

  const formatRatio = (value) => {
    if (value === null || value === undefined) return '-';
    const num = Number(value);
    const color = num >= 1.5 ? 'text-green-600 font-semibold' : num >= 1.0 ? 'text-blue-600' : 'text-orange-600';
    return <span className={color}>{num.toFixed(2)}</span>;
  };

  const formatPercent = (value, showSign = true) => {
    if (value === null || value === undefined) return '-';
    const num = Number(value);
    const color = num >= 15 ? 'text-green-600 font-semibold' : num >= 10 ? 'text-green-600' : 'text-blue-600';
    return (
      <span className={color}>
        {showSign && num >= 0 ? '+' : ''}{num.toFixed(2)}%
      </span>
    );
  };

  return (
    <div className="overflow-x-auto shadow-md rounded-lg">
      <table className="min-w-full bg-white">
        <thead className="bg-gradient-to-r from-purple-600 to-indigo-600 text-white">
          <tr>
            <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider">
              Symbol
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider">
              Action
            </th>
            <th className="px-6 py-3 text-right text-xs font-medium uppercase tracking-wider">
              Current Price
            </th>
            <th className="px-6 py-3 text-right text-xs font-medium uppercase tracking-wider">
              Entry
            </th>
            <th className="px-6 py-3 text-right text-xs font-medium uppercase tracking-wider">
              Target
            </th>
            <th className="px-6 py-3 text-right text-xs font-medium uppercase tracking-wider">
              Stop Loss
            </th>
            <th className="px-6 py-3 text-right text-xs font-medium uppercase tracking-wider">
              Gain
            </th>
            <th className="px-6 py-3 text-right text-xs font-medium uppercase tracking-wider">
              Gain %
            </th>
            <th className="px-6 py-3 text-right text-xs font-medium uppercase tracking-wider">
              R:R
            </th>
            <th className="px-6 py-3 text-right text-xs font-medium uppercase tracking-wider">
              RSI
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200">
          {results.map((stock, index) => (
            <tr
              key={`${stock.symbol}-${index}`}
              className="hover:bg-gray-50 transition-colors"
            >
              <td className="px-6 py-4 whitespace-nowrap">
                <button
                  onClick={() => onChartClick && onChartClick(stock.symbol)}
                  className="text-blue-600 hover:text-blue-800 font-semibold hover:underline cursor-pointer"
                  title="Click to view chart"
                >
                  {stock.symbol}
                </button>
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <button
                  onClick={() => onTradeClick(stock.symbol)}
                  className="px-4 py-2 bg-purple-600 text-white rounded-md hover:bg-purple-700 transition-colors font-medium"
                >
                  Trade
                </button>
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-right text-gray-900">
                ₹{formatNumber(stock.current_price)}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-right text-gray-900">
                ₹{formatNumber(stock.entry_price)}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-right text-green-700 font-semibold">
                ₹{formatNumber(stock.target_price)}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-right text-red-700">
                ₹{formatNumber(stock.stop_loss)}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-right text-gray-900">
                ₹{formatNumber(stock.potential_gain)}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-right">
                {formatPercent(stock.gain_percent)}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-right">
                {formatRatio(stock.risk_reward_ratio)}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-right text-gray-900">
                {formatNumber(stock.rsi, 1)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default LongTermResultsTable;

